import styled from 'styled-components';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import HOC from '../HOC';
import Container from '../../common/Container';
import LinkButton from '../../common/LinkButton';
import { __ } from '../../locales';
import Devider from '../../common/Devider';
import images from '../../images';
import { saveInteraction } from '../../helpers/gamification';
import { syncState } from '../../helpers/iframeHelper';
import { trackEvent } from '../../helpers/common';
import events from '../../app/events';
import CustomButton from '../../common/CustomButton';

const Body = styled.h4`
  margin-bottom: 10px;
`;

const Title = styled.h1`
  margin-bottom: 10px;
  text-align: center;
`;

const Score = styled.h1`
  text-align: center;
  margin-bottom: 15px;
`;

const BadgeContainer = styled.div`
  padding: 40px 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BadgeImage = styled.div`
  width: 220px;
  height: 220px;
  background-image: url('${({ src }) => src}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

const CongratsChips = styled.div`
  width: 80%;
  height: 80%;
  top: -100px;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background-image: url('${images.congrats_chips}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;

const QuizFeedback = ({
  quizData,
  gamificationData,
  learningModulesRedux
}) => {
  const { state } = useLocation();
  const { type = 'rf' } = useParams();

  const quizType = {
    rf: {
      quiz: 'rfQuiz',
      data: 'recyclingFundamentals',
      success: 'hasPassedRfQuiz',
      badgePath: 'https://cdn.recyclecoach.com/app-badges/fundamentals.png',
      interactionQuizKey: 'DID_PASS_RF_QUIZ',
      landEvent: events.DZ_RF_QUIZ_FEEDBACK_LAND,
      successBadge: 'Fundamentals',
      viewIncorrectAnswers: 'DZ_RF_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP'
    },
    lm: {
      quiz: 'lmQuiz',
      data: 'learningModules',
      success: 'hasPassedLmQuiz',
      badgePath: learningModulesRedux[state.lmIndex]?.badge.image_path,
      interactionQuizKey: 'DID_PASS_LM_QUIZ',
      landEvent: 'DZ_LM_QUIZ_FEEDBACK_LAND',
      successBadge: learningModulesRedux[state.lmIndex]?.badge.title,
      viewIncorrectAnswers: 'DZ_LM_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP'
    },
    mum: {
      quiz: 'mumQuiz',
      data: 'misundestoodMaterials',
      success: 'hasPassedMmQuiz',
      badgePath: 'https://cdn.recyclecoach.com/app-badges/misunderstood.png',
      interactionQuizKey: 'DID_PASS_MM_QUIZ',
      landEvent: events.DZ_MM_QUIZ_FEEDBACK_LAND,
      successBadge: 'Misunderstood',
      viewIncorrectAnswers: 'DZ_MM_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP'
    }
  };

  const { replace } = useHistory();
  const quizes = state?.isLearningModule ? quizData.quizState[quizType[type].quiz][state.lmIndex]
    : quizData.quizState[quizType[type].quiz];
  const didPass = gamificationData[quizType[type].success];
  const badgeIconPath = quizType[type].badgePath;
  const successfulItems = Object
    .keys(quizes)
    .filter((key) => quizes[key].passed);
  const total = Object.keys(quizes).length;
  const title = didPass ? __('app.success') : __('app.so_close');
  const description = didPass ? `${__('app.congratulation')}, ${__('app.you_earned', {
    badge: quizType[type].successBadge,
    // eslint-disable-next-line no-nested-ternary
    lesson_type: (type === 'rf') ? __('app.recycling_fundamentals') : (type === 'lm') ? __('app.learning_modules') : __('app.misunderstood_materials')
  })}` : __('app.what_they_do_next');

  const showResults = () => {
    replace(`/quiz-results/${type}`, {
      lmIndex: state?.lmIndex,
      isLearningModule: state?.isLearningModule
    });
  };

  const haveAtLeastOneMistake = Object
    .keys(quizes)
    .map((key) => quizes[key])
    .some(({ failed }) => failed);

  useEffect(() => {
    trackEvent(quizType[type].landEvent, { passed: didPass });
  }, [type, didPass]);

  useEffect(() => {
    if (didPass) {
      saveInteraction({
        type: quizType[type].interactionQuizKey,
        state: true
      });
      syncState();
    }
  }, [type, didPass]);

  return (
    <div>
      <Container>
        <BadgeContainer>
          {
            didPass
              ? (
                <CongratsChips />
              ) : null
          }
          <BadgeImage
            src={badgeIconPath}
          />
        </BadgeContainer>
        <Title>
          {title}
        </Title>
        <Score>
          {successfulItems.length}
          /
          {total}
        </Score>
        <Body>
          {description}
        </Body>
        {
          haveAtLeastOneMistake
            ? (
              <LinkButton
                onClick={() => {
                  trackEvent(quizType[type].viewIncorrectAnswers, { passed: didPass });
                  showResults();
                }}
              >
                {__('app.view_incorrect_answers')}
              </LinkButton>
            ) : null
        }
        <Devider />
        {
          didPass
            ? (
              <CustomButton
                style={{ margin: '5px 0' }}
                className="btn outline royal"
                onClick={() => replace('/landing')}
              >
                {__('app.close')}
              </CustomButton>
            ) : null
        }
      </Container>
    </div>
  );
};

export default HOC(QuizFeedback);
